import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=7b731fa6&scoped=true&"
import script from "./OurStory.vue?vue&type=script&lang=js&"
export * from "./OurStory.vue?vue&type=script&lang=js&"
import style0 from "./OurStory.vue?vue&type=style&index=0&id=7b731fa6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b731fa6",
  null
  
)

export default component.exports